<template>
	<section class="u-popular u-popular__container">
		<div class="u-popular-title">Популярные проекты</div>
		<div class="u-popular-wrapper">
			<div class="u-popular-card" v-for="card in cards">
				<div class="u-popular-card-wrapper">
					<div class="u-popular-card__img">
						<img
							:src="
								card.props.photo.src && card.props.photo.size > 0
									? card.props.photo.src
									: '/static/v2/src/img/urban/fund/no-img.jpg'
							"
							:alt="card.props.city.value"
						/>
						<div class="u-popular-card__img-title">
							<svg
								width="11"
								height="12"
								viewBox="0 0 11 12"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<circle
									cx="5.48079"
									cy="6"
									r="5.33333"
									:fill="setColor(card.props.type.code) || '#82BF00'"
								/>
							</svg>
							<span>{{ card.props.type.value }}</span>
						</div>
					</div>
					<div class="u-popular-card-content">
						<div class="u-popular-card__geo">
							{{ card.props.region.value }}, {{ card.props.city.value }}
						</div>
						<div class="u-popular-card__title">{{ card.name }}</div>
						<a
							:href="card.url"
							:title="card.name"
							target="_blank"
							class="u-popular-card__link"
							>Подробнее
							<svg
								width="13"
								height="10"
								viewBox="0 0 13 10"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M12.2737 5.48011C12.5494 5.21495 12.5494 4.78505 12.2737 4.51989L7.78151 0.198869C7.50585 -0.0662898 7.05891 -0.0662898 6.78324 0.198869C6.50758 0.464029 6.50758 0.893936 6.78324 1.1591L10.0704 4.32102H1.18635C0.796503 4.32102 0.480469 4.62501 0.480469 5C0.480469 5.37499 0.796503 5.67898 1.18635 5.67898H10.0704L6.78324 8.8409C6.50758 9.10606 6.50758 9.53597 6.78324 9.80113C7.05891 10.0663 7.50585 10.0663 7.78151 9.80113L12.2737 5.48011Z"
									fill="white"
								/>
							</svg>
						</a>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'Popular',
	props: {},

	data() {
		return {
			colorHint: [
				{ code: 'spatial_development', color: '#82BF00' },
				{ code: 'design_project', color: '#5B90E0' },
			],
		}
	},
	watch: {
		// Здесь можно добавить наблюдатели
	},

	beforeCreate() {
		// Вызывается до создания экземпляра компонента
	},

	created() {
		// Вызывается после создания экземпляра компонента
	},

	beforeMount() {
		// Вызывается перед монтированием компонента
	},

	mounted() {
		// Вызывается после монтирования компонента
	},

	computed: {
		// Здесь можно добавить вычисляемые свойства
		...mapState({
			cards: state => state.popular.data.slice(0, 3),
		}),
	},
	methods: {
		// Здесь можно добавить методы
		setColor(code) {
			return this.colorHint.find(el => el.code === code).color
		},
	},
}
</script>
